module.exports = __webpack_public_path__ + "img/13.6712b755.jpg";